document.addEventListener('DOMContentLoaded', () => {
    const faqQuestions = document.querySelectorAll('.js-faq-question');

    faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
            const answer = question.nextElementSibling;
            const isActive = question.classList.contains('is-active');

            // すべての回答を閉じる（1つずつ開かせたい場合）
            faqQuestions.forEach(otherQuestion => {
                otherQuestion.classList.remove('is-active');
                otherQuestion.nextElementSibling.style.maxHeight = null;
            });

            // クリックされた要素が元々閉じていれば開く
            if (!isActive) {
                question.classList.add('is-active');
                // 内容の高さに合わせて開く
                answer.style.maxHeight = answer.scrollHeight + "px";
            }
        });
    });
});

function initMegaMenuHover() {
  const menus = document.querySelectorAll('details.mega-menu');

  menus.forEach((menu) => {
    const summary = menu.querySelector('summary');
    let closeTimer;

    summary.addEventListener('click', (e) => {
      if (window.matchMedia('(min-width: 990px)').matches) {
        e.preventDefault();
      }
    });

    menu.addEventListener('mouseenter', () => {
      if (!window.matchMedia('(min-width: 990px)').matches) return;

      clearTimeout(closeTimer);
      menu.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('mouseleave', () => {
      if (!window.matchMedia('(min-width: 990px)').matches) return;

      closeTimer = setTimeout(() => {
        menu.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 300);
    });
  });
}

document.addEventListener('DOMContentLoaded', initMegaMenuHover);